import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  bookCar,
  cleanBookingData,
  clearBookCarData,
  stripeSessionGet,
} from "../../redux/Slice/bookingSlice";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import SuccessModal from "../RentYourCar/PaymentSuccessModal";
import { getUserDetail } from "../../redux/Slice/authSlice";
import noDataImg from "../../assets/no-data-found.png";
import ClipLoader from "react-spinners/ClipLoader";
const PaymentRedirect = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const baseURL = useSelector((state) => state?.config?.baseURL);
  const bookingInfo = useSelector((state) => state?.booking?.bookingInfo);
  const personalDetailsData = useSelector(
    (state) => state?.booking?.personalDetailsData
  );
  const bookCarData = useSelector((state) => state?.booking?.bookCarData);
  const document = useSelector((state) => state?.booking?.documentsData);
  const withDriver = useSelector((state) => state?.booking?.withDriver);
  const rent = useSelector((state) => state?.booking?.rent);
  const bookingAmount = useSelector((state) => state?.booking?.bookingAmount);

  // const [differenceInDays, setDifferenceInDays] = useState(null);
  const userDetail = useSelector((state) => state?.auth?.userDetail);
  const { loginId } = useSelector((state) => state?.auth);

  const carId = useSelector((state) => state?.booking?.carId);
  const [base64Data, setBase64Data] = useState({});
  const [isPaid, setIsPaid] = useState(false);
  const [noData, setNoData] = useState(false);
  const bookCarStatus = useSelector((state) => state?.booking?.bookCarStatus);
  const bookingDays = useSelector((state) => state?.booking?.bookingDays);
  function calculateDifference(start, end) {
    const differenceInMilliseconds = Math.abs(end - start);
    return Math.ceil(differenceInMilliseconds / (1000 * 60 * 60 * 24));
  }

  useEffect(() => {
    setBase64Data({
      idFront: base64StringToSyntheticFile(document?.idFront),
      licenceFront: base64StringToSyntheticFile(document?.licence),
    });
  }, [document]);

  useEffect(() => {
    // const daysDifference = calculateDifference(
    //   dayjs(bookingInfo?.pickUp),
    //   dayjs(bookingInfo?.dropOff)
    // );
    // setDifferenceInDays(daysDifference);

    async function bookingCreateHandler() {
      if (JSON.stringify(base64Data).length >= 5) {
        const data = await dispatch(getUserDetail(loginId));
        if (data?.payload?.data?.stripeSessionId) {
          const stripeSession = await dispatch(
            stripeSessionGet(data?.payload?.data?.stripeSessionId)
          );
        
          if (stripeSession?.payload?.data?.data?.payment_status === "paid") {
            setIsPaid(true);
           
            carBookingHandler();
          }
        } else {
          setNoData(true);
        }
      }
    }
    // DPO  token verify code 
    
    // const result = await verifyToken();
    bookingCreateHandler();
  }, [base64Data]);
  useEffect(() => {
    return () => {
      dispatch(clearBookCarData());
      // dispatch(cleanBookingData());
    };
  }, []);
  // useEffect(() => {

  // }, [differenceInDays])
  // useEffect(() => {
  //   const daysDifference = calculateDifference(
  //     dayjs(bookingInfo?.pickUp),
  //     dayjs(bookingInfo?.dropOff)
  //   );
  //   setDifferenceInDays(daysDifference);

  //   return () => {
  //     dispatch(clearBookCarData())
  //   }
  // }, []);

  const notify = () => toast(`${bookCarData?.data?.message}`);
  useEffect(() => {
    if (bookCarStatus === "success" && bookCarData.status === 200) {
      dispatch(cleanBookingData());
      notify();
      setTimeout(() => {
        navigate("/mybooking");
      }, 4000);
      dispatch(getUserDetail(userDetail?.data?._id));
    }
    if (bookCarStatus === "false" && bookCarData.status === 200) {
      notify();
    }
  }, [bookCarStatus, bookCarData]);

  function base64StringToSyntheticFile(
    base64String,
    fileName = "image.png",
    fileType = "image/png"
  ) {
    if (base64String) {
      if (base64String.includes("base64")) {
        // Split the base64 string by comma to separate metadata from data
        const parts = base64String.split(",");
        // Extract the metadata part which contains the data type and base64 prefix
        const metadata = parts[0];
        // Split the metadata part by semicolon to separate data type and parameters
        const metadataParts = metadata.split(";");
        // Extract the data type which contains the MIME type and encoding
        const dataType = metadataParts[0];
        // Extract the file extension from the data type
        const extension = dataType.split("/")[1];

        fileType = dataType;
        fileName = `image.${extension}`;
        // Check if the base64 string contains a data URI prefix
        let str = base64String.substr(base64String.indexOf(",") + 1);
        // Log the base64 string before decoding

        // Convert base64 string to Blob
        const byteCharacters = atob(str);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: fileType });

        // Create synthetic file object
        const syntheticFile = new File([blob], fileName, {
          type: fileType,
        });

        return syntheticFile;
      } else {
        return base64String;
      }
    }
  }

  const carBookingHandler = () => {
    // window.open(`https://nodeapp.shrinkcom.com/kwacharides-backend/pay/displayGateWay/${totalAmount}`,'_blank')
    const currentDate = dayjs(); // Get current time from system
    let finalPickUpDate = bookingInfo?.pickUp;
    let pickUpDate = dayjs(bookingInfo?.pickUp);
    // Check if pickUpDate is today
    if (pickUpDate.isSame(currentDate, "day")) {
      // Check if pickUpDate is in the past
      if (
        pickUpDate.isBefore(currentDate, "minute") ||
        (pickUpDate.isSame(currentDate, "minute") &&
          pickUpDate.isBefore(currentDate, "second"))
      ) {
        // Update pickUpDate to current time
        let currentDateTime = new Date();
        const formattedDate = currentDateTime.toISOString();
        finalPickUpDate = formattedDate;
      }
    }

    const daysDifference = calculateDifference(
      dayjs(finalPickUpDate),
      dayjs(bookingInfo?.dropOff)
    );
    const formData = new FormData();
    formData.append("userId", userDetail?.data?._id);
    formData.append("carId", carId);
    formData.append("pickUpDateandTime", finalPickUpDate); // update time if pickupt time is less then current
    // formData.append("pickUpDateandTime", bookingInfo?.pickUp);
    formData.append("returnDateandTime", bookingInfo?.dropOff);
    formData.append("name", personalDetailsData?.name);
    formData.append("email", personalDetailsData?.emailId);
    formData.append("phone", personalDetailsData?.phoneNumber);
    // formData.append("UserPhoneNumber", personalDetailsData?.phoneNumber);
    formData.append("country_code", "+"+personalDetailsData?.countryCode);
    formData.append("address", personalDetailsData?.address);
    formData.append("bookWithDriver", withDriver);
    formData.append("driverRent", rent?.driverRent);
    formData.append("paymentStatus", "Completed");
    // formData.append("noOfBookingDays", bookingDays);
    formData.append("noOfBookingDays", daysDifference); // after date time changes
    formData.append("amount", rent?.carRent);
    formData.append("totalAmount", bookingAmount);
    formData.append(
      "identityFront",
      base64Data.idFront ? base64Data.idFront : document.idFront
    );
    formData.append(
      "drivingLicenseFront",
      base64Data.licenceFront ? base64Data.licenceFront : document.licence
    );
    if (formData) {
      dispatch(bookCar(formData));
    }
  };

  return (
    <>
      {noData && !isPaid ? (
        <div className="container-fluid">
          <div className="row justify-content-center mt-5">
            <img
              className="col-lg-4 text-center  w-160 "
              src={noDataImg}
              alt="no data found"
            />
            <h4 className="text-center mt-5 accentColor">
              "No Data Found...."
            </h4>
          </div>
        </div>
      ) : (
        <>
          {isPaid ? (
            <div className="container-fluid">
              <SuccessModal />
            </div>
          ) : (
            <div className="container-fluid">
              <div className="row justify-content-center mt-5">
                {/* <img
                  className="col-lg-4 text-center  w-160 "
                  src={noDataImg}
                  alt="no data found"
                />
                <h4 className="text-center mt-5 accentColor">
                  "No Data Found...."
                </h4> */}
                <ClipLoader
                  color="#008080"
                  loading={!isPaid ? true : false}
                  // cssOverride={{ height: "30px" }}
                  size={130}
                  aria-label="Loading Spinner"
                  data-testid="loader"
                />
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default PaymentRedirect;
